<template>
    <div>
        <div class="d-flex align-items-center justify-content-between text-sm mb-2"
            v-for="option in travelOptionPrices"
            v-if="option.quantity > 0"
            :key="option.id"
        >
            <span>{{ option.label }}</span>
            <span v-if="option.quantity > 1">(x{{ option.quantity }})</span>
            <span>{{ formatPrice(option.gross_price * option.quantity, travel.currency) }}</span>
        </div>
    </div>
</template>


<script>
    import { mapGetters } from 'vuex';

    export default {
        computed: {
            ...mapGetters({
                travelOptionPrices: 'berbus/getTravelOptionPrices',
                travel: 'berbus/getTravel',
            }),
        },
    };
</script>
